module.exports = __webpack_public_path__ + "static/media/mobileCranesImg.8c36699b.png";